import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteFinanceAccountsService } from "@/features/accounts/finance/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useDeleteFinanceAccountStates } from "@/features/accounts/finance/hooks/use-delete-accounts-states";
import { useContext } from "react";


export const useDeleteFinanceAccount = () => {
  const {
    financeAccountId,
    setFinanceAccountId,
    institutionType,
    setInstitutionType,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useDeleteFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deleteFinanceAccountsService = new DeleteFinanceAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関削除
  const deleteFinanceAccounts = async (
    accountGroupId: string,
    financeAccountId: string,
    financeId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteFinanceAccountsService.deleteFinanceAccounts({
        account_group_id: accountGroupId,
        finance_account_id: financeAccountId,
        finance_id: financeId,
      });
      return true;
      // 成功時の処理
    } catch (error) {
      // エラーハンドリング
      console.log("deleteFinanceAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    financeAccountId,
    setFinanceAccountId,
    institutionType,
    setInstitutionType,
    isShowErrorDialog,
    setIsShowErrorDialog,
    deleteFinanceAccounts: errorHandledAsync(deleteFinanceAccounts, setError),
  };
};
